import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SOLAR_ARTICLES } from "@/data/solarArticles";
import { RETIRED_GUIDE_SLUGS } from "@/data/legacyGuideRedirects";

export default function RelatedArticles({ currentSlug, relatedSlugs = [], maxItems = 4 }) {
  const related = relatedSlugs
    .map((slug) => SOLAR_ARTICLES.find((a) => a.slug === slug))
    .filter((article) => article && !RETIRED_GUIDE_SLUGS.has(article.slug))
    .slice(0, maxItems);

  if (related.length === 0) return null;

  return (
    <div className="mt-12 pt-8 border-t border-border">
      <h3 className="font-heading font-bold text-xl mb-5">Related Guides</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {related.map((article) => (
          <Link
            key={article.slug}
            to={`/solar-guides/${article.slug}`}
            className="group flex items-start gap-3 p-4 bg-secondary/40 rounded-xl hover:bg-secondary transition-colors border border-border hover:border-accent/30"
          >
            <ArrowRight className="w-4 h-4 text-accent shrink-0 mt-0.5 group-hover:translate-x-0.5 transition-transform" />
            <div>
              <p className="text-sm font-heading font-semibold group-hover:text-accent transition-colors leading-snug">
                {article.title}
              </p>
              <p className="text-xs text-muted-foreground mt-0.5 line-clamp-1">{article.metaDescription}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}